import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isImageChoice(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.IMAGE_CHOICE && typeof label === 'string' && Array.isArray(value) && value.every(item => typeof item === 'string');
}
export function formatImageChoice(submission) {
  if (!isImageChoice(submission) || submission.value.length === 0) {
    return undefined;
  }
  return {
    label: submission.field.view.label,
    value: submission.value
  };
}
//# sourceMappingURL=image-choice-preview.js.map